module.exports = __webpack_public_path__ + "static/media/haustier.146605af.svg";